import { createSlice } from '@reduxjs/toolkit';
import { remove } from 'lodash';
import { arrayMove } from '@dnd-kit/sortable';
import { UiState as UiStateEnum } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  photos: {
    byId: {},
    ids: []
  },
  currentImageId: null,
  uiState: UiStateEnum.Idle
};

const setCurrentImageId = (draft, action) => {
  draft.currentImageId = action.payload;
};

function setUiState(draft, uiState) {
  draft.uiState = uiState;
}

const addPhotos = (draft, action) => {
  const {
    photos
  } = action.payload;

  if (!photos) {
    draft.photos = initialState.photos;
    return;
  }

  photos.forEach(photo => {
    draft.photos.byId[photo.id] = photo;
    draft.photos.ids.push(photo.id);
  });
  setUiState(draft, UiStateEnum.Success);
};

const setPhotoOrientation = (draft, action) => {
  const {
    id,
    orientation
  } = action.payload;
  if (!id || draft.photos.ids.length === 0 || !draft.photos.byId[id]) return;
  draft.photos.byId[id].orientation = orientation;
};

const fetchPhotosRequest = draft => {
  setUiState(draft, UiStateEnum.Pending);
};

const uploadPhotoFiles = draft => {
  setUiState(draft, UiStateEnum.Pending);
};

const setUiStateFailure = draft => {
  setUiState(draft, UiStateEnum.Failure);
};

const removePhoto = (draft, action) => {
  const {
    id
  } = action.payload;
  remove(draft.photos.ids, photoId => photoId === id);
};

const changePhotoOrder = (draft, action) => {
  const {
    oldIndex,
    newIndex
  } = action.payload;
  const reorderedAssignedPhotos = arrayMove(draft.photos.ids, oldIndex, newIndex);
  draft.photos.ids = reorderedAssignedPhotos;
};

const submitEditedPhoto = draft => {
  // TODO: for next imgly test iteration add loader for specific photo
  setUiState(draft, UiStateEnum.Pending);
};

const submitEditedPhotoSuccess = draft => {
  // TODO: for next imgly test iteration add loader for specific photo
  setUiState(draft, UiStateEnum.Success);
};

const updateExistingPhoto = (draft, action) => {
  const {
    photo,
    imageToReplaceId
  } = action.payload;
  draft.photos.byId[photo.id] = photo;

  if (imageToReplaceId) {
    const index = draft.photos.ids.indexOf(imageToReplaceId);
    draft.photos.ids[index] = photo.id;
    delete draft.photos.byId[imageToReplaceId];
  } else {
    draft.photos.ids.push(photo.id);
  }
};

const mediaUpload = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setCurrentImageId,
    addPhotos,
    setPhotoOrientation,
    removePhoto,
    changePhotoOrder,
    fetchPhotosRequest,
    fetchPhotosSuccess: addPhotos,
    fetchPhotosFailure: setUiStateFailure,
    uploadPhotoFiles,
    uploadPhotoSuccess: addPhotos,
    uploadPhotoFailure: setUiStateFailure,
    submitEditedPhoto,
    updateExistingPhoto,
    submitEditedPhotoSuccess,
    submitEditedPhotoFailure: setUiStateFailure
  }
});
export const {
  actions
} = mediaUpload;
export const plug = {
  [stateName]: mediaUpload.reducer
};
export default mediaUpload.reducer;